var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const filterRoutes = (routes, ancestorPaths, compareFn) => {
    const newRoutes = [];
    if (Array.isArray(routes)) {
        for (let i = 0; i < routes.length; i++) {
            const route = routes[i];
            const routePath = route.path;
            if (!Array.isArray(ancestorPaths)) {
                ancestorPaths = [];
            }
            let newRoute = null;
            if (compareFn(route, ancestorPaths)) {
                const _a = route || {}, { children } = _a, others = __rest(_a, ["children"]);
                newRoute = Object.assign({}, others);
                newRoutes.push(newRoute);
            }
            const routeChildren = route.children;
            if (newRoute && Array.isArray(routeChildren) && routeChildren.length) {
                const children = filterRoutes(routeChildren, [...ancestorPaths, routePath], compareFn);
                if (Array.isArray(children) && children.length) {
                    newRoute.children = children;
                }
            }
        }
    }
    return newRoutes;
};
function parsePath(path) {
    if (!path) {
        return;
    }
    let hash = "";
    const query = {};
    const hashIndex = path.indexOf("#");
    if (hashIndex >= 0) {
        hash = path.slice(hashIndex);
        path = path.slice(0, hashIndex);
    }
    const queryIndex = path.indexOf("?");
    if (queryIndex >= 0) {
        const queryStr = path.slice(queryIndex + 1);
        if (queryStr) {
            const paramPairStrArr = queryStr.split("&");
            if (Array.isArray(paramPairStrArr)) {
                paramPairStrArr.forEach((paramPairStr) => {
                    const paramPairArr = paramPairStr.split("=");
                    if (Array.isArray(paramPairArr)) {
                        query[paramPairArr[0]] = paramPairArr[1];
                    }
                });
            }
        }
        path = path.slice(0, queryIndex);
    }
    return {
        path,
        query,
        hash,
    };
}
export { filterRoutes, parsePath };
